export function hasFileProperty(obj: Record<string, any>): boolean {
  for (const key in obj) {
    // Ensure property belongs to the object and not its prototype chain
    if (Object.hasOwn(obj, key) && obj[key] instanceof File) {
      return true
    }
  }
  return false
}

/**
 * The first own File property on an entity, or undefined.
 *
 * Companion to hasFileProperty above, same own-property + `instanceof File`
 * idiom. Used to name the offending file when the API rejects an upload as too
 * large (services/http/post.ts) — by then buildPostBody has turned the entity
 * into an opaque FormData, but the entity itself is still in scope.
 */
export function firstFileProperty(
  obj: Record<string, any>
): File | undefined {
  for (const key in obj) {
    if (Object.hasOwn(obj, key) && obj[key] instanceof File) {
      return obj[key] as File
    }
  }
  return undefined
}
